import { useCallback, useMemo, useState } from 'react';
import { isInsideAppleAppStoreApp } from './billing.ts';
import { isIPhone } from './platform.ts';

export const useLongPress = (onLongPress: any, onClick: any, { delay = 300 } = {}) => {
  const [longPressTriggered, setLongPressTriggered] = useState(false);
  const [timeout, setTimeout] = useState<number | undefined>();

  const start = useCallback(() => {
    setLongPressTriggered(false);
    setTimeout(
      window.setTimeout(() => {
        onLongPress();
        setLongPressTriggered(true);
      }, delay),
    );
  }, [delay, onLongPress]);

  const clear = useCallback(() => {
    if (timeout !== undefined) {
      clearTimeout(timeout);
      setTimeout(undefined);
    }
  }, [timeout]);

  const onMaybeClick = useCallback(() => {
    if (!longPressTriggered) {
      onClick();
    }
    setLongPressTriggered(false);
  }, [longPressTriggered, onClick]);

  const onMouseDown = isInsideAppleAppStoreApp() || isIPhone() ? undefined : start;
  const onMouseUp = isInsideAppleAppStoreApp() || isIPhone() ? undefined : clear;
  const onMouseLeave = isInsideAppleAppStoreApp() || isIPhone() ? undefined : clear;

  const result = useMemo(
    () => ({
      onMouseDown,
      onTouchStart: start,
      onMouseUp,
      onMouseLeave,
      onTouchEnd: clear,
      onClick: onMaybeClick,
    }),
    [clear, onMaybeClick, onMouseDown, onMouseLeave, onMouseUp, start],
  );

  return result;
};
